module.exports = __webpack_public_path__ + "static/media/poster_wide_s2.d609f725.png";